import { queryCache } from 'react-query';
import { resetReduxPersist } from 'src/redux/store';
import { resetStoreAction } from 'src/redux/rootActions';
import Icons from 'react-native-alternate-icons';
import * as Sentry from '@sentry/react-native';
import { isIOS, isWeb } from 'src/utils';
import webchatIframe from 'src/utils/webchatIframe';
import { useSelector } from 'react-redux';
import { updateAuthAction } from 'src/redux/auth/actions';
import { chatgenieAPI } from 'src/lib/api/chatgenieApi';
import { userFlows } from 'src/constants';
import { isEmpty } from 'lodash';
import { useDispatchMapper } from './actionHooks';

const isValidParams = (params) => params?.email && params?.companyName && params?.fullname;

export const useAuth = () => {
  const state = useSelector((store) => store.auth);
  const updateState = useDispatchMapper(updateAuthAction);

  const isEmailFound = async (email) => {
    if (!email) throw Error('Email is missing');
    try {
      const result = await chatgenieAPI.searchUser(email);
      return !!result.data?.data?.email;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const loginWithParams = async (params) => {
    let updatedState = {};
    if (params.flow === 'customer') {
      updatedState.flow = userFlows.EXISTING_USER;
      updatedState.flowViaLink = true;
    }
    if (isValidParams(params)) {
      const isFound = await isEmailFound(params.email);
      updatedState = {
        flow: isFound ? userFlows.EXISTING_USER : userFlows.NEW_USER,
        email: params.email,
        fullname: params.fullname,
        companyName: params.companyName,
        isPortalIntegration: true,
      };
    }
    if (!isEmpty(updatedState)) {
      updateState(updatedState);
    }
  };

  const resetRedux = useDispatchMapper(resetStoreAction);
  const logout = (callback) => {
    try {
      // clear react-query cache
      queryCache.clear();
      if (isIOS()) {
        // reset protek icon on iOS
        Icons.getIconName((currentIcon) => {
          if (currentIcon === 'ProtechIcon') {
            Icons.reset();
          }
        });
      }
      if (isWeb()) {
        // reset messenger iframe state
        webchatIframe.logout();
      }

      resetRedux();
      resetReduxPersist();

      if (window?.ipc) {
        // reset electron state
        window.ipc?.send('logout');
      }
      Sentry.configureScope((scope) => scope.setUser(null));
    } catch (err) {
      console.log(err);
    } finally {
      if (callback) {
        callback();
      }
    }
  };
  return {
    logout,
    state,
    updateState,
    loginWithParams,
    isEmailFound,
  };
};
